import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'app-complaint-chat',
  templateUrl: './complaint-chat.component.html',
  styleUrls: ['./complaint-chat.component.scss']
})
export class ComplaintChatComponent implements OnInit {
  ComplaintChatForm:FormGroup;
  ComplaintList: any=[];
  emptyText: boolean=true;
  complaintId: any;
  userImagesize: boolean;
  userImage = "";
  userImageName: any;
  errorFile2: any;
  userImagefilerealimage: any="";
  UserImagefilerealimageflag: any;
  fileName: string;
  file: File;
  isImage: boolean;
  isVideo: boolean;
  currentUserDetails: any;
  isChat: boolean;
  constructor(private service: AuthService,private router:Router, private toastr: ToastrService,private modalService: NgbModal,
    config: NgbModalConfig, private ngxService: NgxUiLoaderService,private activatedRoute:ActivatedRoute,
    private formBuilder: FormBuilder) {
    this.ComplaintChatForm = this.formBuilder.group({
      description: ["", Validators.required]
    });
    this.activatedRoute.params.subscribe(params => {
      if (params.complaintId) {
       this.complaintId=params.complaintId;
        
      }

    });
   }
   trigger() {
    let element = document.getElementById('upload_file') as HTMLInputElement;
    element.click();
  }


  removeFile() {
    this.UserImagefilerealimageflag = false;
    this.userImage = "";
    this.userImageName = "";
    this.userImagefilerealimage="";
  }
  ngOnInit(): void {
    console.log(this.complaintId);
    this.currentUserDetails = localStorage.getItem('retailorName');

    // this.getComplaintApi('INPROGRESS');
    this.getChat();

  }
  getChat(){
 
     this.service.getChat().subscribe((res:any)=>{
      this.ComplaintList=[res];
      if(this.ComplaintList[0].staus=='INPROCESS'){
        this.isChat=true;
      }else{
        this.isChat=false;

      }
      
      if(this.ComplaintList==''){
      this.router.navigate(['complaint']);

      }
      console.log(this.ComplaintList);

     },err=>{
     this.ngxService.stop();
 
     })
     
   }
  getComplaintApi(status){
   this.ngxService.start();

    this.service.getComplaint(status).subscribe((res:any)=>{
    this.ngxService.stop();

      if(res.statusCode == 1){
        this.ComplaintList=res.data
      }else {
      }
    },err=>{
    this.ngxService.stop();

    })
    
  }
  sendReply(){
    this.service.reply(this.ComplaintChatForm.value,this.complaintId,this.userImage).subscribe((res:any)=>{
      if(res.statusCode == 1){
        console.log(res);

        this.ComplaintChatForm.reset();
        this.getComplaintbyIdApi(this.complaintId);
        this.removeFile();
      }else {
      }
    },err=>{
  
    })
    
  }
  getComplaintbyIdApi(complaintId){
    this.service.getComplaintbyId(complaintId).subscribe((res:any)=>{

      if(res.statusCode == 1){
        var response=res.data;
        this.ComplaintList=[response]
        
      }else {
      }
    },err=>{

    })
    
  }
  
  OpenList(){
       this.router.navigate(['complaint']);
  }
 
  onSearchChange(searchValue: any): void {  
    console.log(searchValue.length);
    if(searchValue.length){
      this.emptyText=false;

    }else{
      this.emptyText=true;
      
    }

  }
  personalPhoto(event) {
    if (event.target.files[0].size > 32000000) {
      this.userImagesize = true;
    } else {
      this.userImagesize = false;
     if (
        event.target.files[0].type === "image/jpeg" ||
        event.target.files[0].type === "image/png"
       
      ){
        this.isImage=true;
        this.isVideo=false;
      }else if( event.target.files[0].type == "video/mp4" ||
      event.target.files[0].type == "video/x-m4v" ||
      event.target.files[0].type == "video/x-m4v"){
        this.isImage=false;
        this.isVideo=true;
      } 
        this.errorFile2 = "";
        this.userImage = event.target.files[0];
        this.userImageName = event.target.files[0].name;
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          
          this.userImagefilerealimage = reader.result;
        
        this.UserImagefilerealimageflag = true;
      }
    }
  }
}
